import {isValidEmail} from './formatter';
import {DOCUMENT_TYPE} from '../const/documents';

export function businessCustomerValidation(customer) {
    const result = [];
    if (!customer.representativeName) result.push('• Missing Representative Name');
    if (!customer.companyName) result.push('• Missing Company Name');
    if (!customer.address) result.push('• Missing Company Address');
    if (!customer.representativeJobTitle) result.push('• Missing Representative Job Title');
    if (!customer.trn || (customer.trn && customer.trn.toString().includes('_'))) result.push('• Missing TRN');
    if (!customer.representativeEmail || (customer.representativeEmail && !isValidEmail(customer.representativeEmail))) result.push('• Missing Email Address');
    if (!customer.creditLimit) result.push('• Missing Credit Limit');

    const documents = customer.documents || [];
    const documentTypes = documents.map(item => item.documentTypeId);

    if (!customer.isIndividual) {
        if (!documentTypes.includes(DOCUMENT_TYPE.Certification_Of_Incorporation)) result.push('• Missing Certification of Incorporation');
        if (!documentTypes.includes(DOCUMENT_TYPE.Proof_of_Address)) result.push('• Missing Proof of Address for Business');
        if (!documentTypes.includes(DOCUMENT_TYPE.Tax_Compliance_Certification)) result.push('• Missing Tax Compliance Certificate');
    } else {
        if (!documentTypes.includes(DOCUMENT_TYPE.Proof_of_Income)) result.push('• Missing Proof Of Income');
        if (!documentTypes.includes(DOCUMENT_TYPE.Proof_of_Address)) result.push('• Missing Proof of Address');
        if (!documentTypes.includes(DOCUMENT_TYPE.Gov_ID)) result.push('• Missing Government ID');
    }

    if (result.length) result.unshift('Missing Fields:');

    return result;
}
